export default __webpack_public_path__ + "static/media/profile5.5e422bf8.png";